import { Alert, Snackbar } from "components/ui/MaterialAdapter";
import React, { useEffect, useRef, useState } from "react";

const FaceDetector = () => {
  const videoRef = useRef(null);
  const [openWarning, setOpenWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");

  const handleClose = () => {
    setOpenWarning(false);
  };

  useEffect(() => {
    let mounted = true;
    let brightnessInterval;

    const stopStream = () => {
      const tracks = videoRef.current?.srcObject?.getTracks?.() || [];
      tracks.forEach((track) => track.stop());
    };

    const analyzeBrightness = () => {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      if (!context) return;

      brightnessInterval = window.setInterval(() => {
        const video = videoRef.current;
        if (!mounted || !video || video.readyState !== 4) return;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        if (!canvas.width || !canvas.height) return;

        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const frame = context.getImageData(0, 0, canvas.width, canvas.height);
        let brightness = 0;
        for (let i = 0; i < frame.data.length; i += 4) {
          brightness +=
            (frame.data[i] + frame.data[i + 1] + frame.data[i + 2]) / 3;
        }
        brightness /= frame.data.length / 4;

        if (brightness < 30) {
          setWarningMessage("Camera is blocked or too dark.");
          setOpenWarning(true);
        } else {
          setOpenWarning(false);
        }
      }, 1000);
    };

    const startVideo = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });

        if (!mounted) {
          stream.getTracks().forEach((track) => track.stop());
          return;
        }

        const video = document.createElement("video");
        video.muted = true;
        video.playsInline = true;
        video.srcObject = stream;
        videoRef.current = video;
        await video.play().catch(() => undefined);
        console.log("Video stream started.");
        analyzeBrightness();
      } catch (err) {
        console.error("Error accessing camera:", err);
        if (mounted) {
          setWarningMessage("Camera access is blocked.");
          setOpenWarning(true);
        }
      }
    };

    startVideo();

    return () => {
      mounted = false;
      if (brightnessInterval) window.clearInterval(brightnessInterval);
      stopStream();
      videoRef.current = null;
    };
  }, []);

  return (
    <div id="warning-snackbar-container">
      <Snackbar
        id="snackbar-dynamic-warning"
        open={openWarning}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          id="alert-dynamic-warning"
          onClose={handleClose}
          severity="warning"
          sx={{ width: "100%" }}
        >
          <strong>Warning:</strong> {warningMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default FaceDetector;
